import React, { useState, useEffect } from "react";
import DevelopersPagination from "@shared/navbars/DevelopersNavbar/Pagination";
import { getUserPurchasedInterests } from "@services/krentDeveloper";
import { formatDate, numberWithCommas } from "@utils/helpers";
import { useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE = 10;

const PurchasedInterests = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [purchases, setPurchases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState<any>({});
  const [totalPages, setTotalPages] = useState(1);

  const [error, setError] = useState<Error | null>(null);
  const fetchPurchases = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const abortController = new AbortController();
      const response = await getUserPurchasedInterests(abortController.signal);
      setPurchases(response.data);
      setTotalPages(
        Math.ceil(
          response.data.length / ITEMS_PER_PAGE ||
            pagination.totalItems / ITEMS_PER_PAGE
        )
      );

      setPagination(response.pagination);
    } catch (err) {
      setError(err as any);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchPurchases();
  }, []);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentPurchases = purchases?.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>{error.message || "Something went wrong"}</div>;

  return (
    <div>
      <PurchaseList purchases={currentPurchases} startIndex={startIndex} />
      <DevelopersPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

const PurchaseList = ({
  purchases,
  startIndex,
}: {
  purchases: any[];
  startIndex: number;
}) => (
  <div className="my-20">
    {purchases?.length < 1 ? (
      <div className="text-center">
        <h4>No purchases made</h4>
      </div>
    ) : (
      purchases.map((item, idx) => (
        <PurchaseCard key={idx} item={item} index={startIndex + idx} />
      ))
    )}
  </div>
);

const PurchaseCard = ({ item, index }: { item: any; index: number }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/purchase-details/${item._id}`, {
      state: { purchases: true, item },
    });
  };
  return (
    <div className="sale-interest-card flex justify-between">
      <div className="flex gap-4">
        <h6>{index + 1}.</h6>
        <div>
          <h6 className="fs-10">Initiation date</h6>
          <p>{formatDate(item.createdAt || "")}</p>
        </div>
        {item.property?.coverImages ||
        item?.property?.otherImages?.length > 0 ? (
          <img
            src={
              item.property.coverImages
                ? item.property.coverImages[0]
                : item?.property?.otherImages[0]
            }
            className=""
            alt="building"
          />
        ) : (
          <div
            className=""
            style={{
              width: "120px",
              height: "100px",
              backgroundColor: "#f3f3f3",
              borderRadius: "10px",
            }}
          ></div>
        )}

        <div>
          <h5>{item.property.propertyName}</h5>
          <h6>
            {item.property.currency}&nbsp;
            {numberWithCommas(item.property.price)}
          </h6>
          <PropertyDetails
            bedrooms={item.property.numberOfBedrooms}
            bathrooms={item.property.numberOfBathrooms}
          />
        </div>
      </div>
      <div className="text-center">
        <h6 className="fs-12">
          Documentation {item.documentationProgress}%
          <br />(
          {item.documentationProgress === 100 ? "Completed" : "in progress"})
        </h6>
        <div
          className="progress-bar-wrapper"
          style={{
            backgroundColor: "#f3f3f3",
            borderRadius: "10px",
            height: "10px",
            width: "100%",
            marginTop: "10px",
          }}
        >
          <div
            className="progress-bar"
            style={{
              width: `${item.documentationProgress}%`,
              height: "100%",
              backgroundColor: "#47BBA9",
              borderRadius: "10px",
              transition: "width 0.5s ease-in-out",
            }}
          />
        </div>
      </div>

      <div>
        <button
          onClick={handleViewDetails}
          className="bg-primary text-white rounded-10 "
        >
          View Purchase Details
        </button>
      </div>
    </div>
  );
};
const PropertyDetails = ({
  bedrooms,
  bathrooms,
}: {
  bedrooms: number;
  bathrooms: number;
}) => (
  <div className="flex gap-4">
    <div className="flex gap-2 items-center">
      <i className="fa-regular fa-bed-front text-primary"></i>
      <h6>{bedrooms}</h6>
    </div>
    <div className="flex gap-2 items-center">
      <i className="fa-regular fa-bath text-primary"></i>
      <h6>{bathrooms}</h6>
    </div>
  </div>
);

export default PurchasedInterests;
